import request from "../shared/http";
import appConfig from "../shared/js/app-config";

const getServiceId = () => appConfig.getServiceId();

export default {
  listLocal(serviceId = getServiceId()) {
    return request.get(`/payment_config/${serviceId}/list`).then((res) => res?.data ?? res);
  },

  listFromMeta(serviceId = getServiceId()) {
    return request.get(`/payment_config/${serviceId}/meta`).then((res) => res?.data ?? res);
  },

  getFromMeta(serviceId, configurationName) {
    return request.get(
      `/payment_config/${serviceId}/meta/${encodeURIComponent(configurationName)}`
    ).then((res) => res?.data ?? res);
  },

  create(serviceId, body) {
    return request.post(`/payment_config/${serviceId}`, body).then((res) => res?.data ?? res);
  },

  regenerateOAuth(serviceId, configurationName) {
    return request.post(`/payment_config/${serviceId}/regenerate_oauth`, {
      configuration_name: configurationName,
    }).then((res) => res?.data ?? res);
  },

  updateDataEndpoint(serviceId, configurationName, dataEndpointUrl) {
    return request.post(`/payment_config/${serviceId}/data_endpoint`, {
      configuration_name: configurationName,
      data_endpoint_url: dataEndpointUrl,
    }).then((res) => res?.data ?? res);
  },

  remove(serviceId, configurationName) {
    return request.delete(`/payment_config/${serviceId}`, {
      data: { configuration_name: configurationName },
    }).then((res) => res?.data ?? res);
  },

  setActive(serviceId, configId) {
    return request.put(`/payment_config/${serviceId}/activate`, { config_id: configId }).then(
      (res) => res?.data ?? res
    );
  },

  updateCredentials(serviceId, configId, keyId, keySecret) {
    return request.put(`/payment_config/${serviceId}/credentials`, {
      config_id: configId,
      key_id: keyId,
      key_secret: keySecret,
    }).then((res) => res?.data ?? res);
  },
};
